import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { IdOrientation } from "../../constants/IdOrientation";
import { utilGrid } from "../../utils/grid/utilGrid";
import { BF2CreateAsset, BF2PositionSurroundingPiece } from "../BF2BuildingGraphicsUtils";
export var GetDirtPieceIso = function (data, orientation, baseSetup) {
    var config = artConfigBuildings["dirtPiece"];
    var sprite = BF2CreateAsset(config.assets[0], false);
    sprite.name = "Dirt Piece [" + orientation + "]";
    BF2PositionSurroundingPiece(sprite, orientation, 0, baseSetup);
    var pos;
    if (orientation === IdOrientation.Right) {
        sprite.scale.x *= -1;
        sprite.scale.y *= -1;
        pos = utilGrid.mapToScreen(0, baseSetup.expansionsSizeY);
        // Magic numbers to make dirt align without dabbling too much into transformation matrix
        sprite.position.x += pos.x - 10;
        sprite.position.y += pos.y - 10;
    }
    else if (orientation === IdOrientation.Up) {
        sprite.scale.x *= -1;
        sprite.scale.y *= -1;
        pos = utilGrid.mapToScreen(baseSetup.expansionsSizeX, 0);
        // Magic numbers to make dirt align without dabbling too much into transformation matrix
        sprite.position.x += pos.x;
        sprite.position.y += pos.y - 10;
    }
    return sprite;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/fence/GetDirtPieceIso.ts
// module id = 2213
// module chunks = 3